import React from 'react';
import AdminLayout from '../../components/templates/layout/AdminLayout';
import SystemConfigPanel from '../../components/templates/admin/SystemConfigPanel';

const SystemConfigPage = () => {
    return (
        <AdminLayout>
            <SystemConfigPanel />
        </AdminLayout>
    );
};

export default SystemConfigPage;
